import React from 'react';
import { PhoneboardManagement } from '@/widgets/phoneboard-management';

export const PhoneboardManagementPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <PhoneboardManagement />
    </div>
  );
};